import { cookies } from "@constants/cookies";
import Cookies from "js-cookie";
import { abTestIdentifiers } from "./storage";

export const getLsParametersCookie = () => {
	return Cookies.get(cookies.COOKIE_LS_PARAMETERS);
};

export const updateStorageCookie = () => {
	if (typeof window === "undefined") {
		return;
	}

	const AE3KeysFromStorageToSave = Object.entries(localStorage)
		.filter((storageAE3) => storageAE3[0].substring(0, 4) === "AE3_")
		.map((storageAE3) => {
			const treatedAE3Key = storageAE3[0].replace("AE3_", "").replace("_rf", "");

			const valuesIfAbTestExists = abTestIdentifiers.find((abTestIdentifier) => abTestIdentifier.key.toLowerCase() === treatedAE3Key);
			if (valuesIfAbTestExists) {
				return [valuesIfAbTestExists.id, storageAE3[1]];
			}
			return [treatedAE3Key, storageAE3[1]];
		});

	Cookies.remove(cookies.COOKIE_LS_PARAMETERS);

	// Cookies.set(
	//   COOKIE_LS_PARAMETERS,
	//   qs.stringify(Object.fromEntries(AE3KeysFromStorageToSave)),
	//   { expires: 365 }
	// )
};
